import { ElMessage } from 'element-plus';
import { showDialog } from '@/utils/dialog';
import { nextTick } from 'vue';
import { useThrottleFn } from '@vueuse/core';
import { useI18n } from '@/hooks/web/useI18n';
import { getLoginModule } from '@/components/Dialog/Login';

const { t } = useI18n();

export const OVER_TIME_ERROR = Symbol();

const showLogin = useThrottleFn(() => {
    nextTick(async () => {
        // showDialog((await import('@/components/Dialog/Login/Login.vue')).default, {
        //     config: { single: true, zIndex: 1000 },
        // })?.show();
        const module = await import('@/components/Dialog/Login/Login.vue');
        showDialog(module.default, {
            config: { single: true, zIndex: 1000 },
        })?.show();

    });
}, 500);

export default class Error {
    static error(code: number, error: any) {}
    static net(payload: any) {
        const { error, data } = payload;
        const type = Object.prototype.toString
            .call(error)
            .slice(8, -1)
            .toLowerCase();
        switch (type) {
            case 'string':
                if (error == 'no token') {
                    showLogin();
                } else {
                    ElMessage.warning(error || t('common.errText.badNet'));
                }
                throw { error, data };
                break;
            case 'function':
                error(data);
                throw { error, data };
                break;

            case 'undefined':
                data
                    ? failCallback(data)
                    : ElMessage.warning(t('common.errText.badNet'));
                throw { error, data };
                break;

            default:
                ElMessage.warning(data.msg || t('common.errText.badNet'));
                throw { error, data };
        }
        throw data ? data : '';
    }

    static CODE = {
        SYS: 'SYS',
        API: 'API', 
        NET: 'NET', 
        COM: 'COM',
    };
}

const failCallbackMap: Record<string | number, Function> = {
    50001: showLogin,
    50102: showLogin,
    50103: showLogin,
    50104: showToast(t('common.errText.badNet')),
    50601: showToast(),
    50602: showToast(),
    80105: showToast(t('common.errText.stageLocked')),
};

function showToast(content?: string) {
    return function (msg: string) {
        ElMessage.warning(content || msg);
    };
}

export function failCallback(data: any, env: any = null) {
    failCallbackMap[data.code]
        ? env
            ? failCallbackMap[data.code]?.call?.(env)
            : failCallbackMap[data.code]?.(data.msg)
        : data.msg && ElMessage.warning(data.msg);
}
